import { Box, Button, Stack, Typography } from "@mui/material";
import { ArrowBack, ArrowDownward, ArrowForward, ArrowUpward, CenterFocusStrong, NorthEast, NorthWest, SouthEast, SouthWest } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { baseUrl, DOWNLOAD_FILE } from "../../api/endpoints.js";
import "./image-framing.css";

const anchors = [
  [0, 0, "بالا چپ", NorthWest], [50, 0, "بالا وسط", ArrowUpward], [100, 0, "بالا راست", NorthEast],
  [0, 50, "وسط چپ", ArrowBack], [50, 50, "مرکز", CenterFocusStrong], [100, 50, "وسط راست", ArrowForward],
  [0, 100, "پایین چپ", SouthWest], [50, 100, "پایین وسط", ArrowDownward], [100, 100, "پایین راست", SouthEast],
];

/** Edits physical image framing without changing or re-uploading the source asset. */
export default function ImageFramingEditor({ file, galleryId, mobile, value, onChange, disabled }) {
  const [localSource, setLocalSource] = useState(null);
  useEffect(() => {
    if (!(file instanceof Blob)) { setLocalSource(null); return; }
    const source = URL.createObjectURL(file);
    setLocalSource(source);
    return () => URL.revokeObjectURL(source);
  }, [file]);
  const source = localSource || (galleryId ? `${baseUrl}/${DOWNLOAD_FILE}/${galleryId}?size=original&v=framing-1` : null);
  return <Stack spacing={2} sx={{ my: 2 }}>
    <Typography component="h3" variant="subtitle2">نمایش تصویر در بنر</Typography>
    {source && <Box sx={{ position: "relative", width: "100%", aspectRatio: mobile ? "2 / 1" : "16 / 5", bgcolor: "background.default", overflow: "hidden", borderRadius: 2, border: 1, borderColor: "divider" }}>
      <Box component="img" src={source} alt="پیش‌نمایش برش بنر" sx={{ width: "100%", height: "100%" }}
        style={{ objectFit: value.imageFit, objectPosition: `${value.positionX}% ${value.positionY}%` }} />
    </Box>}
    <Button fullWidth disabled={disabled} variant={value.imageFit === "cover" ? "contained" : "outlined"}
      aria-pressed={value.imageFit === "cover"} sx={{ borderRadius: 2, minHeight: 40,
        ...(value.imageFit === "cover" ? { bgcolor: "#ff4d00", color: "#fff", "&:hover": { bgcolor: "#e64500" } } : {}) }}
      onClick={() => onChange({ ...value, imageFit: value.imageFit === "cover" ? "contain" : "cover" })}>
      {value.imageFit === "cover" ? "نمایش کامل تصویر" : "کاور تصویر"}
    </Button>
    {value.imageFit === "cover" && <Box component="fieldset" sx={{ border: 0, m: 0, p: 0 }}>
      <Typography component="legend" variant="body2">موقعیت تصویر در حالت کاور</Typography>
      <Box dir="ltr" className="dk-image-framing-anchors" style={{ direction: "ltr" }} sx={{ display: "grid", gridTemplateColumns: "repeat(3, 40px)", justifyContent: "center", gap: 0.5, mt: 1 }}>
        {anchors.map(([x, y, label, Icon]) => {
          const selected = value.positionX === x && value.positionY === y;
          return <Button key={`${x}-${y}`} disabled={disabled} aria-label={label} title={label} variant={selected ? "contained" : "outlined"}
            aria-pressed={selected} sx={{ minWidth: 40, width: 40, height: 40, p: 0, borderRadius: 2,
              ...(selected ? { bgcolor: "#ff4d00", color: "#fff", "&:hover": { bgcolor: "#e64500" } } : { borderColor: "divider", color: "text.primary" }) }}
            onClick={() => onChange({ ...value, positionX: x, positionY: y })}><Icon sx={{ width: 16, height: 16 }} /></Button>;
        })}
      </Box>
    </Box>}
  </Stack>;
}
